import { FC } from 'react';

import Box from '@mui/material/Box';

import { Options, useOption } from 'lib';
import { PackageStatus } from '__generated__/PackageStatus_package.graphql';

export const optionsConfig: Options<PackageStatus> = {
  DRAFT: {
    label: 'Ruošinys',
    color: 'info',
  },
  EXPIRED: {
    label: 'Pasibaigęs galiojimas',
    color: 'error',
  },
  PUBLISHED: {
    label: 'Publikuotas',
    color: 'success',
  },
  WAITING: {
    label: 'Neprasidėjęs',
    color: 'warning',
  },
};

type Props = {
  status: PackageStatus;
};

const PackageStatusText: FC<Props> = ({ status }) => {
  const { color, label } = useOption(status, optionsConfig);

  return (
    <Box component="span" color={color}>
      {label}
    </Box>
  );
};

export default PackageStatusText;
